module.exports = __webpack_public_path__ + "static/img/tilted-jump-pad_256.bf25279.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tilted-jump-pad_256.png
// module id = bCVT
// module chunks = 0